import getDecryptedData from "@/utils/decrypt";
import { profileSlug } from "@/helpers/profileSlug";

function getUser() {
  const encrypted = localStorage.getItem('userData');
  if(!encrypted || encrypted === 'undefined') return null;

    return getDecryptedData(encrypted, process.env.VUE_APP_CRYPTO_KEY || "@qG56W5w04YI");
}

export function authGuard(to, from, next) {
  if(to.name == 'Login') return next();

  const user = getUser();

  if(!user || user.status !== 200) {
    return next('/');
  }
 
  const abilityRecord = to.matched.find(function(route) { return route.meta && route.meta.ability; });
  const requiredAbility = abilityRecord ? abilityRecord.meta.ability : null;
  if(requiredAbility && (user.abilities || []).indexOf(requiredAbility) === -1) {
    return next('/dashboard');
  }

  const profileRecord = to.matched.find(function(route) { return route.meta && route.meta.profiles; });
  const allowedProfiles = profileRecord ? profileRecord.meta.profiles : null;
  if(allowedProfiles && allowedProfiles.indexOf(profileSlug(user.profile)) === -1) {
    return next('/dashboard');
  }

  next();
}
